import React, {useState,useEffect,useRef} from 'react'
import { Formik, Field } from 'formik'
import { Table,Button,Icon,Form,Select,Input,List,Image,Label,TextArea,Message } from 'semantic-ui-react'

import {WindowReload, WindowURL, WindowLocation} from '../../config/settings'
import Alertmessage from '../../config/alert'
import axios from 'axios'
import renderHTML from 'react-render-html'
import {validateStep2} from './validate'


export default function OpenAccountStep3(props) {

	function CallbackFunction(data){
		props.active(data);
	}
	function CallbackState(data){
		props.callstate(data);
	}


	/*-------------------------------------------------------------------------
	 Forms: Adding
	--------------------------------------------------------------------------*/
	const [errortrading, seterrortrading] = useState(false);
	const [erroraccount, seterroraccount] = useState(false);
	const [state,setstate] = useState({
		trading_1:props.state.trading_1,
		trading_2:props.state.trading_2,
		trading_3:props.state.trading_3,
		trading_4:props.state.trading_4,
		account_type:props.state.account_type,
	});

	function handleSubmitForm(values, props){

		let errore = 0;
		if(values.trading_1==0&&values.trading_2==0&&values.trading_3==0&&values.trading_4==0){
			seterrortrading(true);
			errore=1;
		}
		if(values.account_type==0){
			seterroraccount(true);
			errore=1;
		}
		if(errore==1){
			return false;
		}

		CallbackState({
			trading_1:values.trading_1,
			trading_2:values.trading_2,
			trading_3:values.trading_3,
			trading_4:values.trading_4,
			account_type:values.account_type,
    });

		if(values.account_type==1){
			CallbackFunction(41);
		}else{
			CallbackFunction(42);
		}



	}
	/*-------------------------------------
		Content
	--------------------------------------*/
	const [content, setcontent] = useState({
			form: {
				step3: {
					title:'',
					content:'',
					message:'',
					message2:'',
				},
				country: {
					title:'',
					content:'',
				}
			},
	});
	function ContentApplication(){
		let formData = new FormData();
		formData.append('type','content');
		axios.post('/content/request.php',formData)
		.then(function (response) {
				let obj = response.data;
				setcontent({
					...content,
					form: {
						step3: {
							title:obj.form.step3.title,
							content:obj.form.step3.content,
							message:obj.form.step3.message,
							message2:obj.form.step3.message2,
						},
						country: {
							title:obj.form.country.title,
							content:obj.form.country.content,
						}
					},
				});
		})
		.catch(function (error){
		});
	}

	useEffect(()=>{
		ContentApplication();
	},[]);


	return (
		<React.Fragment>
				<Form>
					<Formik
					  enableReinitialize
						initialValues={state}
						onSubmit={handleSubmitForm}
						render={formProps => {
						const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, touched, setFieldValue } = formProps
						return(
			         <div className="open-account-panel">
                 <div className="open-account-panel-header">
                   <h2>{content.form.step3.title}</h2>
									 <Message visible warning><Icon name="info circle"/>{content.form.step3.message}</Message>
									 {content.form.step3.content!=''?renderHTML(content.form.step3.content):''}
									 <Message visible negative>{content.form.step3.message2}</Message>
                </div>
			            <div className="open-account-panel-body">


                      <div className="application-box">
											  <h3>What will you be trading</h3>

			                  <div className="input-chekbox-wrapper">
													 <span onClick={()=>{
														 if(values.trading_1==0){
															 setFieldValue('trading_1',1)
														 }else{
															 setFieldValue('trading_1',0)
														 }
													 }}><Icon name={values.trading_1==0?'circle outline':'check circle outline active'}/>Equities (Stocks, ETFs and Options)</span>
												</div>
												<div className="input-chekbox-wrapper">
													 <span onClick={()=>{
														 if(values.trading_2==0){
															 setFieldValue('trading_2',1)
														 }else{
															 setFieldValue('trading_2',0)
														 }
													 }}><Icon name={values.trading_2==0?'circle outline':'check circle outline active'}/>DPV/RPV (Institutional Account)</span>
												</div>
												<div className="input-chekbox-wrapper">
													 <span onClick={()=>{
														 if(values.trading_3==0){
															 setFieldValue('trading_3',1)
														 }else{
															 setFieldValue('trading_3',0)
														 }
													 }}><Icon name={values.trading_3==0?'circle outline':'check circle outline active'}/>Futures / Options</span>
												</div>
												<div className="input-chekbox-wrapper">
													 <span onClick={()=>{
														 if(values.trading_4==0){
															 setFieldValue('trading_4',1)
														 }else{
															 setFieldValue('trading_4',0)
														 }
													 }}><Icon name={values.trading_4==0?'circle outline':'check circle outline active'}/>Forex</span>
												</div>
												{errortrading&&<Label className="customerrorlabel"><i className="uil-multiply"></i>Choose atleast one on what will you be trading.</Label>}

										 </div>


									   <div className="application-box topspace">
										  <h3>Select the account type you need</h3>
											<div className="input-chekbox-wrapper">
												 <span onClick={()=>{setFieldValue('account_type',1);}}><Icon name={values.account_type==1?'dot circle outline active':'circle outline'}/>Individual</span>
											</div>
											<div className="input-chekbox-wrapper">
												 <span onClick={()=>{setFieldValue('account_type',2);}}><Icon name={values.account_type==2?'dot circle outline active':'circle outline'}/>Joint</span>
											</div>
											<div className="input-chekbox-wrapper">
												 <span onClick={()=>{setFieldValue('account_type',3);}}><Icon name={values.account_type==3?'dot circle outline active':'circle outline'}/>Joint as Tenants-in-Common</span>
											</div>
											<div className="input-chekbox-wrapper">
												 <span onClick={()=>{setFieldValue('account_type',4);}}><Icon name={values.account_type==4?'dot circle outline active':'circle outline'}/>Corporate</span>
											</div>
											<div className="input-chekbox-wrapper">
												 <span onClick={()=>{setFieldValue('account_type',5);}}><Icon name={values.account_type==5?'dot circle outline active':'circle outline'}/>Limited Liability Company</span>
											</div>
											<div className="input-chekbox-wrapper">
												 <span onClick={()=>{setFieldValue('account_type',6);}}><Icon name={values.account_type==6?'dot circle outline active':'circle outline'}/>Sole Proprietorship</span>
											</div>
											{erroraccount&&<Label className="customerrorlabel"><i className="uil-multiply"></i>Select account. This is required.</Label>}
									</div>


									</div>{/*.panel-body*/}
			            <div className="open-account-panel-footer">
										<div className="account-panel-footer">
											<div><Button content='Back' className="primary" icon='left arrow' labelPosition='left' onClick={()=>CallbackFunction(2)}/></div>
											<div><Button content='Continue' className="primary" icon='right arrow' labelPosition='right' onClick={handleSubmit}/></div>
										</div>
									</div>
			         </div>

						 )}}/>
					</Form>
    </React.Fragment>
  )
}
